var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreroll = function SvgPreroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0A1F21",
    strokeMiterlimit: 10,
    strokeWidth: 2.16,
    clipPath: "url(#preroll_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.06 2.3c-.04-.74-.69-1.29-1.43-1.21l-2.82.29c-.69.07-1.21.68-1.16 1.38l.12 1.86c.01.22-.16.41-.38.41h-2.86c-.45 0-.88.24-1.11.63L1.28 19.42c-.73 1.22.74 2.56 1.88 1.71L16.98 10.4c.35-.26.55-.69.52-1.13l-.16-2.4c-.01-.22.16-.41.38-.41h2.21c.75 0 1.34-.63 1.29-1.38l-.17-2.79z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.17 14.13.94 4.71M9.68 8.02l1.28 7.05M13.73 5.3 15 11.94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "preroll_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.33v22.48H0z"
  })))));
};
export default SvgPreroll;